import List from "./List";

const routes = [
    {
        path: 'courses',
        element: <List />
    }
]
export default routes;